import Load from 'components/Load';
import { createNavigationalRoute } from 'modules/app/components/NavigationalLayout';
import { RouteDescriptor, createRouteHandle } from 'routing/types';
import basePath from 'utils/basePath';

const AsyncLocalSearch = Load(
  () =>
    import(
      /* webpackChunkName: "local-search" */ './containers/LocalSearchContainer'
    ),
  {},
  true,
);

const AsyncLocalSearchPage = Load(
  () =>
    import(
      /* webpackChunkName: "local-search-page" */ './containers/LocalSearchPageContainer'
    ),
  {},
  true,
);

export const localSearchRoute: RouteDescriptor = {
  id: 'locals.search',
  path: `${basePath}/locals/*`,
  label: 'Local Search',
  audience: 'both',
  layout: 'navigational',
  module: 'locals',
};

export const localSearchPageRoute: RouteDescriptor = {
  id: 'locals.page',
  path: `${basePath}/l/*`,
  label: 'Local Search Page',
  audience: 'both',
  layout: 'navigational',
  module: 'locals',
};

export const localsRoutes = [
  createNavigationalRoute({
    key: localSearchRoute.id,
    id: localSearchRoute.id,
    path: localSearchRoute.path,
    component: AsyncLocalSearch,
    handle: createRouteHandle(localSearchRoute),
    showBottomNavigation: true,
    showSearchInNavbar: true,
  }),
  createNavigationalRoute({
    key: localSearchPageRoute.id,
    id: localSearchPageRoute.id,
    path: localSearchPageRoute.path,
    component: AsyncLocalSearchPage,
    handle: createRouteHandle(localSearchPageRoute),
    showBottomNavigation: true,
    showFullSearchInNavbar: true,
    showSearchInNavbar: true,
  }),
];

export const localsRouteDescriptors = [localSearchRoute, localSearchPageRoute];

export default localsRoutes;
